export const TestData: any = {
  step1: {
    action: {
      name: 'IsSessionParam2Empty',
      description: 'Is [[session:param:2]](3rdParty) Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:2]]',
      },
      result: {
        yes: 'step2',
        no: 'step3',
      },
    },
    type: 'action',
  },
  step2: {
    action: {
      name: 'IsSessionParam1Empty',
      description: 'Is [[session:param:1]](BundleSelection) Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:1]]',
      },
      result: {
        yes: 'step4',
        no: 'step82',
      },
    },
    type: 'action',
  },
  step3: {
    action: {
      name: 'IsSessionParam1Valid',
      description: 'Is [[session:param:1]] between 0 and 3',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]',
          c: '3',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step37',
        no: 'step87',
      },
    },
    type: 'action',
  },
  step4: {
    menu: {
      menuHeader: 'Purchase Data for:',
      menuType: 'menuOption',
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: 'Self',
            next: 'step5',
          },
          '2': {
            text: '3rd Party',
            next: 'step35',
          },
        },
      },
    },
    type: 'menu',
    next: '_MENU_END_',
  },
  step5: {
    action: {
      name: 'IsNetworkEqualsMTN',
      description: 'Is [[session:network]] = MTN',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '4',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step6',
        no: 'step11',
      },
    },
    type: 'action',
  },
  step6: {
    menu: {
      menuType: 'multipleChoice',
      menuHeader: 'Select MTN Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1GB 30days N1000',
          },
          '2': {
            text: '3.5GB 30days N2000',
          },
          '3': {
            text: '50MB 1day N100',
          },
          '4': {
            text: '100MB 1day N200',
          },
          '5': {
            text: '750MB 7days N500',
          },
          '6': {
            text: '10GB 30 days N5000',
          },
        },
      },
    },
    type: 'menu',
    next: 'step7',
  },
  step7: {
    action: {
      name: 'IsMTNBundleValid',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step8',
        no: 'step6',
      },
    },
    type: 'action',
  },
  step8: {
    action: {
      name: 'remapMTNBundle2product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '167',
          '2': '170',
          '3': '161',
          '4': '162',
          '5': '166',
          '6': '174',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step9',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step9: {
    action: {
      name: 'remapMTNBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '500',
          '6': '5000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step10',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step10: {
    action: {
      name: 'MTNPrepaidDataAPI',
      description: 'Call SOAP API - GTBank MTN Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'Self_Prepaid_DataAPI',
        body: '{"amount": [[remapMTNBundle2Amount:result]]00,"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remapMTNBundle2product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[session:msisdn]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result10: 'step29',
        result11: 'step29',
        result12: 'step31',
        result13: 'step32',
      },
      result: {
        '0000': 'step29',
        other: 'step29',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step11: {
    action: {
      name: 'IsNetworkEqualsEtisalat',
      description: 'Is [[session:network]] = Etisalat',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '1',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step12',
        no: 'step17',
      },
    },
    type: 'action',
  },
  step12: {
    menu: {
      menuHeader: 'Select 9Mobile Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1GB 30days N1000',
          },
          '2': {
            text: '2.5GB 30days N2000',
          },
          '3': {
            text: '40MB 1day N100',
          },
          '4': {
            text: '150MB 7days N200',
          },
          '5': {
            text: '1.5GB 30days N1200',
          },
          '6': {
            text: '11GB 30days N8000',
          },
        },
      },
      menuType: 'multipleChoice',
    },
    type: 'menu',
    next: 'step13',
  },
  step13: {
    action: {
      name: 'IsEtisalatBundleValid',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step14',
        no: 'step12',
      },
    },
    type: 'action',
  },
  step14: {
    action: {
      name: 'remapEtisalatBundle2product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '209',
          '2': '211',
          '3': '187',
          '4': '251',
          '5': '253',
          '6': '217',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step15',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step15: {
    action: {
      name: 'remapEtisalatBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '1200',
          '6': '8000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step16',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step16: {
    action: {
      name: 'EtisalatPrepaidData',
      description: 'Call SOAP API - GTBank Etisalat Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'Self_Prepaid_DataAPI',
        body: '{"amount": [[remapEtisalatBundle2Amount:result]]00,"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remapEtisalatBundle2product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[session:msisdn]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step30',
        result2: 'step30',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step30',
        other: 'step30',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step17: {
    action: {
      name: 'IsNetworkEqualsAirtel',
      description: 'Is [[session:network]] = Airtel',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '3',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step18',
        no: 'step23',
      },
    },
    type: 'action',
  },
  step18: {
    menu: {
      menuHeader: 'Select Airtel Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1.5GB 30days N999',
          },
          '2': {
            text: '3.5GB 30days N1999',
          },
          '3': {
            text: '30MB 1day N99',
          },
          '4': {
            text: '750MB 14days N499',
          },
          '5': {
            text: '10GB 30days N4999',
          },
        },
      },
      menuType: 'multipleChoice',
    },
    type: 'menu',
    next: 'step19',
  },
  step19: {
    action: {
      name: 'IsAirtelBUNDLEValid',
      description: 'Is [[BUNDLE]] between 0 and 6',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '6',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step20',
        no: 'step18',
      },
    },
    type: 'action',
  },
  step20: {
    action: {
      name: 'remapAirtelBundle2product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '193',
          '2': '235',
          '3': '189',
          '4': '191',
          '5': '199',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step21',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step21: {
    action: {
      name: 'remapAirtelBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '999',
          '2': '1999.01',
          '3': '99',
          '4': '499',
          '5': '4999',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step22',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step22: {
    action: {
      name: 'AirtelPrepaidData',
      description: 'Call SOAP API - GTBank Airtel Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'Self_Prepaid_DataAPI',
        body: '{"amount": [[remapAirtelBundle2Amount:result]]00,"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remapAirtelBundle2product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[session:msisdn]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step88',
        result2: 'step88',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step88',
        other: 'step88',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step23: {
    action: {
      name: 'IsNetworkEqualsGlo',
      description: 'Is [[session:network]] = Glo',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '2',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step24',
        no: 'step33',
      },
    },
    type: 'action',
  },
  step24: {
    menu: {
      menuHeader: 'Select Glo Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1.6GB 30days N1000',
          },
          '2': {
            text: '3.75GB 30days N2000',
          },
          '3': {
            text: '35MB 1day N100',
          },
          '4': {
            text: '100MB 5days N200',
          },
          '5': {
            text: '800MB 7days N500',
          },
          '6': {
            text: '12GB 30days N5000',
          },
        },
      },
      menuType: 'multipleChoice',
    },
    type: 'menu',
    next: 'step25',
  },
  step25: {
    action: {
      name: 'IsGloBUNDLEValid',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step26',
        no: 'step24',
      },
    },
    type: 'action',
  },
  step26: {
    action: {
      name: 'remapGloBundle2product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '300',
          '2': '331',
          '3': '327',
          '4': '328',
          '5': '329',
          '6': '335',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step27',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step27: {
    action: {
      name: 'remapGloBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '500',
          '6': '5000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step28',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step28: {
    action: {
      name: 'GloPrepaidData',
      description: 'Call SOAP API - GTBank Glo Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'Self_Prepaid_DataAPI',
        body: '{"amount": [[remapGloBundle2Amount:result]]00,"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remapGloBundle2product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[session:msisdn]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step89',
        result2: 'step89',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step89',
        Other: 'step89',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step29: {
    menu: {
      menuType: 'displayMenu',
      text: '[[MTNPrepaidDataAPI:responseMessage]]',
    },
    type: 'menu',
  },
  step30: {
    menu: {
      menuType: 'displayMenu',
      text: '[[EtisalatPrepaidData:responseMessage]]',
    },
    type: 'menu',
  },
  step31: {
    menu: {
      menuType: 'displayMenu',
      text: 'Your request is processing. If you did not receive your bundle after 1 Hour, please try again.',
    },
    type: 'menu',
  },
  step32: {
    menu: {
      menuType: 'displayMenu',
      text: 'The service is currently unavailable, please try again in 15 minutes.',
    },
    type: 'menu',
  },
  step33: {
    menu: {
      menuType: 'displayMenu',
      text: 'No data bundles available for your mobile network',
    },
    type: 'menu',
  },
  step34: {
    menu: {
      menuType: 'displayMenu',
      text: 'An error occurred with this service, Please try again later.',
    },
    type: 'menu',
  },
  step35: {
    menu: {
      menuType: 'askInput',
      text: 'Please enter 3rd party mobile number:',
      input: {
        varName: '3RD_PARTY_MSISDN',
        validationPattern: '(^[0]\\d{10})|(^[234]\\d{12})',
        isPrivateVariable: false,
      },
    },
    type: 'menu',
    next: 'step38',
  },
  step37: {
    action: {
      name: 'isValid3rdPartyMSISDN',
      description: 'Is [[3RD_PARTY_MSISDN]] an MSISDN',
      actionType: 'regularExpression',
      actionParams: {
        variables: {},
        variableName: '[[session:param:2]]',
        pattern: '(^[0]\\d{10})|(^[234]\\d{12})',
      },
      result: {
        yes: 'step38',
        no: 'step35',
      },
    },
    type: 'action',
  },
  step39: {
    action: {
      name: 'checkMNPMSISDN',
      description: 'Redis Exists - MNP-MSISDN',
      actionType: 'redis',
      actionParams: {
        redisAction: 'exist',
        key: 'MNP-[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]',
      },
      result: {
        yes: 'step40',
        no: 'step78',
      },
    },
    type: 'action',
  },
  step38: {
    action: {
      name: 'set3rdPartyMSISDN',
      description: 'Redis Set [[3RD_PARTY_MSISDN]]',
      actionType: 'redis',
      actionParams: {
        variables: {},
        redisAction: 'set',
        key: '[[session:msisdn]]-3RD_PARTY_MSISDN',
        expire: '5000',
        value: '[[session:param:2]]||[[3RD_PARTY_MSISDN]]',
      },
      result: {
        yes: 'step39',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step40: {
    action: {
      name: 'is3rdPartyMSISDNEqualsGlo',
      description: 'Is 3RD_PARTY_MSISDN = GLO',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[redis:MNP-([[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]])]]',
          b: '101',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step41',
        no: 'step49',
      },
    },
    type: 'action',
  },
  step41: {
    action: {
      name: 'Is3rdPartySessionParam1Empty',
      description: 'Is [[session:param:1]] Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:1]]',
      },
      result: {
        yes: 'step42',
        no: 'step44',
      },
    },
    type: 'action',
  },
  step42: {
    menu: {
      menuHeader: 'Select GLO Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1.6GB 30days N1000',
          },
          '2': {
            text: '3.75GB 30days N2000',
          },
          '3': {
            text: '35MB 1day N100',
          },
          '4': {
            text: '100MB 5days N200',
          },
          '5': {
            text: '800MB 7days N500',
          },
          '6': {
            text: '12GB 30days N5000',
          },
        },
      },
    },
    type: 'menu',
    next: 'step43',
  },
  step43: {
    action: {
      name: 'isValid3rdPartyBundle',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step44',
        no: 'step42',
      },
    },
    type: 'action',
  },
  step44: {
    action: {
      name: 'remap3rdPartyGloBundle',
      description: 'Remap GLO BundleSelection to Description',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1.6GB 30 Day Data Bundle for N1 000',
          '2': '3.75GB 30 Day Data Bundle for N2 000',
          '3': '35MB 1 Day  Data Bundle for N100',
          '4': '100MB 5 Day  Data Bundle for N200',
          '5': '800MB 7 Day  Data Bundle for N500',
          '6': '12GB 30 Day  Data Bundle for N5 000',
        },
        valueToRemap: '[[BUNDLE]]||[[session:param:1]]',
      },
      result: {
        yes: 'step45',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step45: {
    menu: {
      text: 'Please enter PIN or the last 4 digits on your GTBank debit card to confirm the purchase of [[remap3rdPartyGloBundle:result]] for [[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]] or 0 to Cancel',
      cancel: {
        cancelInput: '0',
        cancelMessage: 'Request cancelled.',
      },
      input: {
        varName: 'AUTHCODE',
        validationPattern: '[0-9]{4}',
        isPrivateVariable: false,
      },
      menuType: 'displayMenu',
    },
    type: 'menu',
    next: 'step46',
  },
  step46: {
    action: {
      name: 'remap3rdPartyGloBundle2Product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '300',
          '2': '331',
          '3': '327',
          '4': '328',
          '5': '329',
          '6': '335',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step47',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step47: {
    action: {
      name: 'remap3rdPartyGloBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '500',
          '6': '5000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step48',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step48: {
    action: {
      name: 'thirdPartyGloPrepaidData',
      description: 'Call SOAP API - GTBank Gift GLO Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'ThirdParty_Prepaid_DataAPI',
        body: '{"amount": [[remap3rdPartyGloBundle2Amount:result]],"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remap3rdPartyGloBundle2Product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]","authCode": "[[AUTHCODE]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step76',
        result2: 'step76',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step76',
        Other: 'step76',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step49: {
    action: {
      name: 'is3rdPartyMSISDNEqualsMTN',
      description: 'Is 3RD_PARTY_MSISDN = MTN',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[redis:MNP-([[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]])]]',
          b: '100',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step50',
        no: 'step58',
      },
    },
    type: 'action',
  },
  step50: {
    action: {
      name: 'Is3rdPartySessionParam1Empty',
      description: 'Is [[session:param:1]] Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:1]]',
      },
      result: {
        yes: 'step51',
        no: 'step53',
      },
    },
    type: 'action',
  },
  step51: {
    menu: {
      menuHeader: 'Select MTN Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1GB 30 days-N1000',
          },
          '2': {
            text: '3.5GB 30 days-N2000',
          },
          '3': {
            text: '50MB 1 day N100',
          },
          '4': {
            text: '100MB 1 day N200',
          },
          '5': {
            text: '750MB 7 days N500',
          },
          '6': {
            text: '10GB 30 days-N5000',
          },
        },
      },
    },
    type: 'menu',
    next: 'step52',
  },
  step52: {
    action: {
      name: 'isValid3rdPartyBundle',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step53',
        no: 'step51',
      },
    },
    type: 'action',
  },
  step53: {
    action: {
      name: 'remap3rdPartyMTNBundle',
      description: 'Remap MTN BundleSelection to Description',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1GB 30 Day Data Bundle for N1 000',
          '2': '3.5GB 30 Day Data Bundle for N2 000',
          '3': '50MB 1 Day  Data Bundle for N100',
          '4': '100MB 1 Day  Data Bundle for N200',
          '5': '750MB 7 Day  Data Bundle for N500',
          '6': '10GB 30 Day  Data Bundle for N5 000',
        },
        valueToRemap: '[[BUNDLE]]||[[session:param:1]]',
      },
      result: {
        yes: 'step54',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step54: {
    menu: {
      text: 'Please enter PIN or the last 4 digits on your GTBank debit card to confirm the purchase of [[remap3rdPartyMTNBundle:result]] for [[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]] or 0 to Cancel',
      cancel: {
        cancelInput: '0',
        cancelMessage: 'Request cancelled.',
      },
      input: {
        varName: 'AUTHCODE',
        validationPattern: '[0-9]{4}',
        isPrivateVariable: false,
      },
      menuType: 'displayMenu',
    },
    type: 'menu',
    next: 'step55',
  },
  step55: {
    action: {
      name: 'remap3rdPartyMTNBundle2Product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '167',
          '2': '170',
          '3': '161',
          '4': '162',
          '5': '166',
          '6': '174',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step56',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step56: {
    action: {
      name: 'remap3rdPartyMTNBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '500',
          '6': '5000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step57',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step57: {
    action: {
      name: 'thirdPartyMTNPrepaidData',
      description: 'Call SOAP API - GTBank Gift MTN Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'ThirdParty_Prepaid_DataAPI',
        body: '{"amount": [[remap3rdPartyMTNBundle2Amount:result]],"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remap3rdPartyMTNBundle2Product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]","authCode": "[[AUTHCODE]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step77',
        result2: 'step77',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step77',
        Other: 'step77',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step58: {
    action: {
      name: 'is3rdPartyMSISDNEqualsEtisalat',
      description: 'Is 3RD_PARTY_MSISDN = Etisalat',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[redis:MNP-([[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]])]]',
          b: '102',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step59',
        no: 'step67',
      },
    },
    type: 'action',
  },
  step59: {
    action: {
      name: 'Is3rdPartySessionParam1Empty',
      description: 'Is [[session:param:1]] Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:1]]',
      },
      result: {
        yes: 'step60',
        no: 'step62',
      },
    },
    type: 'action',
  },
  step60: {
    menu: {
      menuHeader: 'Select 9Mobile Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1GB 30days N1000',
          },
          '2': {
            text: '2.5GB 30days N2000',
          },
          '3': {
            text: '40MB 1 day N100',
          },
          '4': {
            text: '150MB 7days N200',
          },
          '5': {
            text: '1.5GB 30days N1200',
          },
          '6': {
            text: '11GB 30days N8000',
          },
        },
      },
    },
    type: 'menu',
    next: 'step61',
  },
  step61: {
    action: {
      name: 'isValid3rdPartyBundle',
      description: 'Is [[BUNDLE]] between 0 and 7',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '7',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step62',
        no: 'step60',
      },
    },
    type: 'action',
  },
  step62: {
    action: {
      name: 'remap3rdPartyEtisalatBundle',
      description: 'Remap Etisalat BundleSelection to Description',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1GB 30 Day Data Bundle for N1 000',
          '2': '2.5GB 30 Day Data Bundle for N2 000',
          '3': '40MB 1 Day  Data Bundle for N100',
          '4': '150MB 7 Day  Data Bundle for N200',
          '5': '1.5GB 30 Day  Data Bundle for N1 200',
          '6': '11GB 30 Day  Data Bundle for N8 000',
        },
        valueToRemap: '[[BUNDLE]]||[[session:param:1]]',
      },
      result: {
        yes: 'step63',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step63: {
    menu: {
      text: 'Please enter PIN or the last 4 digits on your GTBank debit card to confirm the purchase of [[remap3rdPartyEtisalatBundle:result]] for [[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]] or 0 to Cancel',
      cancel: {
        cancelInput: '0',
        cancelMessage: 'Request cancelled.',
      },
      input: {
        varName: 'AUTHCODE',
        validationPattern: '[0-9]{4}',
        isPrivateVariable: false,
      },
      menuType: 'displayMenu',
    },
    type: 'menu',
    next: 'step64',
  },
  step64: {
    action: {
      name: 'remap3rdPartyEtisalatBundle2Product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '209',
          '2': '211',
          '3': '187',
          '4': '251',
          '5': '253',
          '6': '217',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step65',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step65: {
    action: {
      name: 'remap3rdPartyEtisalatBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1000',
          '2': '2000',
          '3': '100',
          '4': '200',
          '5': '1200',
          '6': '8000',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step66',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step66: {
    action: {
      name: 'thirdPartyEtisalatPrepaidData',
      description: 'Call SOAP API - GTBank Gift Etisalat Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'ThirdParty_Prepaid_DataAPI',
        body: '{"amount": [[remap3rdPartyEtisalatBundle2Amount:result]],"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remap3rdPartyEtisalatBundle2Product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]","authCode": "[[AUTHCODE]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step90',
        result2: 'step90',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step90',
        Other: 'step90',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step67: {
    action: {
      name: 'is3rdPartyMSISDNEqualsAirtel',
      description: 'Is 3RD_PARTY_MSISDN = Airtel',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[redis:MNP-([[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]])]]',
          b: '103',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step68',
        no: 'step33',
      },
    },
    type: 'action',
  },
  step68: {
    action: {
      name: 'Is3rdPartySessionParam1Empty',
      description: 'Is [[session:param:1]] Empty',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '[[session:param:1]]',
      },
      result: {
        yes: 'step69',
        no: 'step71',
      },
    },
    type: 'action',
  },
  step69: {
    menu: {
      menuHeader: 'Select Airtel Data:',
      input: {
        varName: 'BUNDLE',
        isPrivateVariable: false,
      },
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: '1.5GB 30days N999',
          },
          '2': {
            text: '3.5GB 30days N1999',
          },
          '3': {
            text: '30MB 1day N99',
          },
          '4': {
            text: '750MB 14days N499',
          },
          '5': {
            text: '10GB 30days N4999',
          },
        },
      },
    },
    type: 'menu',
    next: 'step70',
  },
  step70: {
    action: {
      name: 'isValid3rdPartyBundle',
      description: 'Is [[BUNDLE]] between 0 and 6',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]||[[BUNDLE]]',
          c: '6',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step71',
        no: 'step69',
      },
    },
    type: 'action',
  },
  step71: {
    action: {
      name: 'remap3rdPartyAirtelBundle',
      description: 'Remap Airtel BundleSelection to Description',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '1.5GB 30 Day Data Bundle for N999',
          '2': '3.5GB 30 Day Data Bundle for N1 999',
          '3': '30MB 1 Day  Data Bundle for N99',
          '4': '750MB 14 Day  Data Bundle for N499',
          '5': '10GB 30 Day  Data Bundle for N4 999',
        },
        valueToRemap: '[[BUNDLE]]||[[session:param:1]]',
      },
      result: {
        yes: 'step72',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step72: {
    menu: {
      text: 'Please enter PIN or the last 4 digits on your GTBank debit card to confirm the purchase of [[remap3rdPartyAirtelBundle:result]] for [[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]] or 0 to Cancel',
      cancel: {
        cancelInput: '0',
        cancelMessage: 'Request cancelled.',
      },
      input: {
        varName: 'AUTHCODE',
        validationPattern: '[0-9]{4}',
        isPrivateVariable: false,
      },
      menuType: 'displayMenu',
    },
    type: 'menu',
    next: 'step73',
  },
  step73: {
    action: {
      name: 'remap3rdPartyAirtelBundle2Product',
      description: 'Remap Bundle to Product ID',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '193',
          '2': '235',
          '3': '189',
          '4': '191',
          '5': '199',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step74',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step74: {
    action: {
      name: 'remap3rdPartyAirtelBundle2Amount',
      description: 'Remap Bundle to Amount',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '1': '999',
          '2': '1999.01',
          '3': '99',
          '4': '499',
          '5': '4999',
        },
        valueToRemap: '[[session:param:1]]||[[BUNDLE]]',
      },
      result: {
        yes: 'step75',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step75: {
    action: {
      name: 'thirdPartyAirtelPrepaidData',
      description: 'Call SOAP API - GTBank Gift Airtel Prepaid Data',
      actionType: 'httpCall',
      actionParams: {
        variables: {},
        headers: {},
        queryString: {},
        apiName: 'ThirdParty_Prepaid_DataAPI',
        body: '{"amount": [[remap3rdPartyAirtelBundle2Amount:result]],"channelId": "7","channelName": "USSD","channelSessionId": "[[session:id]]","clientId": "101","clientTxnRef": "101-[[session:msisdn]]-[[system:currentTimeMillis]]","productId": [[remap3rdPartyAirtelBundle2Product:result]],"sourceIdentifier": "[[session:msisdn]]","targetIdentifier": "[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]","authCode": "[[AUTHCODE]]","timestamp": "[[system:date|yyyy-MM-dd\'T\'HH:mm:ss.SSS]]+02:00"}',
        result1: 'step91',
        result2: 'step91',
        result3: 'step31',
        result4: 'step32',
      },
      result: {
        '0000': 'step91',
        Other: 'step91',
        timeout: 'step31',
        maxPoolConnections: 'step32',
      },
    },
    type: 'action',
  },
  step76: {
    menu: {
      text: '[[thirdPartyGloPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step77: {
    menu: {
      text: '[[thirdPartyMTNPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step78: {
    action: {
      name: 'mnpLookup',
      description: 'Call URL - MNP Lookup',
      actionType: 'httpCall',
      actionParams: {
        headers: {
          'Content-type': 'application/xml',
        },
        queryStrings: {
          numbersToLookUp: '[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]',
          username: 'clickatell_nigeria@anq.com',
          password: 'c0b8c',
          country: '234',
        },
        apiName: '',
      },
      result: {
        timeout: 'step79',
        OK: 'step80',
        Other: 'step79',
      },
    },
    type: 'action',
  },
  step79: {
    menu: {
      menuHeader: 'Please enter 3rd party network:',
      options: {
        optionSeparator: '. ',
        items: {
          '1': {
            text: 'MTN',
            next: 'step50',
          },
          '2': {
            text: '9Mobile',
            next: 'step59',
          },
          '3': {
            text: 'Airtel',
            next: 'step68',
          },
          '4': {
            text: 'Glo',
            next: 'step41',
          },
        },
      },
      menuType: 'menuOption',
    },
    type: 'menu',
    next: '_MENU_END_',
  },
  step80: {
    action: {
      name: 'remap3rdPartyNetwork',
      description: 'Remap [[result.TheOperator]] to VendorId',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          MTN: '100',
          ETS: '102',
          ANG: '103',
          GLO: '101',
        },
        valueToRemap: '[[mnpLookup:TheOperator]]',
      },
      result: {
        yes: 'step81',
        no: 'step79',
      },
    },
    type: 'action',
  },
  step81: {
    action: {
      name: 'set3rdPartyMSISDN',
      description: 'Redis Set MNP-[[3RD_PARTY_MSISDN]]',
      actionType: 'redis',
      actionParams: {
        redisAction: 'set',
        key: 'MNP-[[redis:[[session:msisdn]]-3RD_PARTY_MSISDN]]',
        expire: '2592000',
        value: '[[remap3rdPartyNetwork:result]]',
      },
      result: {
        yes: 'step39',
        no: 'step34',
      },
    },
    type: 'action',
  },
  step82: {
    action: {
      name: 'IsSelfSessionParam1Valid',
      description: 'Is [[session:param:1]] between 0 and 3',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '0',
          b: '[[session:param:1]]',
          c: '3',
        },
        expression: 'a < b && b< c',
      },
      result: {
        yes: 'step83',
        no: 'step87',
      },
    },
    type: 'action',
  },
  step83: {
    action: {
      name: 'IsSelfNetworkEqualsMTN',
      description: 'Is [[session:network]] = MTN',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '4',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step8',
        no: 'step84',
      },
    },
    type: 'action',
  },
  step84: {
    action: {
      name: 'IsSelfNetworkEqualsEtisalat',
      description: 'Is [[session:network]] = Etisalat',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '1',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step14',
        no: 'step85',
      },
    },
    type: 'action',
  },
  step85: {
    action: {
      name: 'IsSelfNetworkEqualsAirtel',
      description: 'Is [[session:network]] = Airtel',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '3',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step20',
        no: 'step86',
      },
    },
    type: 'action',
  },
  step86: {
    action: {
      name: 'IsSelfNetworkEqualsGlo',
      description: 'Is [[session:network]] = Glo',
      actionType: 'math',
      actionParams: {
        variables: {
          a: '[[session:network]]',
          b: '2',
        },
        expression: 'a == b',
      },
      result: {
        yes: 'step26',
        no: 'step33',
      },
    },
    type: 'action',
  },
  step87: {
    menu: {
      text: 'Invalid bundle selection, please dail *737*4# to select your data bundles.',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step88: {
    menu: {
      text: '[[AirtelPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step89: {
    menu: {
      text: '[[GloPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step90: {
    menu: {
      text: '[[thirdPartyEtisalatPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  step91: {
    menu: {
      text: '[[thirdPartyAirtelPrepaidData:responseMessage]]',
      menuType: 'displayMenu',
    },
    type: 'menu',
  },
  start: {
    type: 'start',
    next: 'step1',
  },
};
